import React from 'react';
const NewsletterForm = () => {
  return <div className="w-full overflow-hidden" data-id="element-90">
      <div className="relative w-full" style={{
      maxWidth: '100%'
    }} data-id="element-91">
        <iframe src="https://embeds.beehiiv.com/36c179e3-8fea-4aca-95c7-82a2bd211c30?slim=true" data-test-id="beehiiv-embed" height="52" frameBorder="0" scrolling="no" style={{
        margin: 0,
        borderRadius: '0px !important',
        backgroundColor: 'transparent',
        width: '100%',
        maxWidth: '100%',
        overflow: 'hidden'
      }} data-id="element-92" />
      </div>
    </div>;
};
export default NewsletterForm;